import { useAnalyticsPageView } from '../../hooks/useAnalyticsPageView';

/**
 * Renders nothing — its only job is to call the analytics page-view hook
 * once per render of the React Router subtree, mirroring the pattern of
 * `ScrollToTop`. Place inside `BrowserRouter` so `useLocation` works.
 */
export function AnalyticsTracker() {
  useAnalyticsPageView();
  return null;
}
